import { render, staticRenderFns } from "./EmailAskView.vue?vue&type=template&id=204b94bc&"
import script from "./EmailAskView.vue?vue&type=script&lang=js&"
export * from "./EmailAskView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('204b94bc')) {
      api.createRecord('204b94bc', component.options)
    } else {
      api.reload('204b94bc', component.options)
    }
    module.hot.accept("./EmailAskView.vue?vue&type=template&id=204b94bc&", function () {
      api.rerender('204b94bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/statistics/durginfo-stast-view/EmailAskView.vue"
export default component.exports